import React, { createContext, useContext, useState, useCallback } from 'react';

interface SeoPagesEditorContextType {
  isOpen: boolean;
  openEditor: () => void;
  closeEditor: () => void;
}

const SeoPagesEditorContext = createContext<SeoPagesEditorContextType | undefined>(undefined);

export function SeoPagesEditorProvider({ children }: { children: React.ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openEditor = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeEditor = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <SeoPagesEditorContext.Provider
      value={{
        isOpen,
        openEditor,
        closeEditor,
      }}
    >
      {children}
    </SeoPagesEditorContext.Provider>
  );
}

export function useSeoPagesEditor() {
  const context = useContext(SeoPagesEditorContext);
  if (!context) {
    throw new Error('useSeoPagesEditor must be used within SeoPagesEditorProvider');
  }
  return context;
}
